import { render, staticRenderFns } from "./budget-header.vue?vue&type=template&id=825eaa82&"
import script from "./budget-header.vue?vue&type=script&lang=ts&"
export * from "./budget-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports